<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardBody>
          <template>
            <CIcon
              name="cil-user"
              style="margin-bottom: 5px"
              class="text-danger"
            ></CIcon>
            <label
              v-text="count"
              @click="goToCustomers()"
              style="
                padding-left: 12px;
                font-size: 20px;
                margin-bottom: 0;
                cursor: pointer;
                color: #321fdb;
              "
            ></label>
          </template>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from "axios";

export default {
  name: "WidgetsCustomer",
  data: () => {
    return {
      count: 0,
    };
  },

  computed: {},
  methods: {
    getCount() {
      let self = this;
      axios
        .get(`${this.$apiAdress}/v1/customer/count`)
        .then(function (response) {
          self.count = response.data;
        })
        .catch(function (error) {});
    },
    goToCustomers() {
      const link = `/customers`;
      this.$router.push({ path: link });
    },
  },
  mounted: function () {
    this.getCount();
  },
};
</script>
